import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { SearchEmpleadoRequestDto, SearchEmpleadoItemDto, ExportMediaTypeConstants, GridPageSettings, MenuFuncionCodes } from '../../../../src/app/shared/model';
import { MenuFuncionService, EmpleadoService } from '../../../../src/app/shared/services';

@Component({
  selector: 'app-empleado',
  templateUrl: './empleado-list.component.html',
  styleUrls: ['./empleado-list.component.scss']
})
export class EmpleadoListComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isEstadoSearching: boolean = false;
  isRolSearching: boolean = false;
  canEdit: boolean = false;
  canView: boolean = false;
  canAdd: boolean = false;
  verSoloBloqueados: boolean = false;
  verSoloActivos: boolean = true;

  public pageSizes: number[];
  public pageSettings: PageSettingsModel;
  public query: Query;

  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private menuService: MenuFuncionService,
    private empleadoService: EmpleadoService) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.EMPLEADO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success ){
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.EMPLEADO_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.EMPLEADO_LIST);
          if (this.canView){
            this.loadView();
          } 
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.router.navigate(['/']);
          }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
      (err: HttpErrorResponse) => {
        this.isValidating = false;
        this.sharedFunctions.handleError(err, true);
      });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    
    this.buildForm();
    
    this.setQueryParams();
    this.data = new DataManager({
      url: this.empleadoService.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.empleadoService.getAuthorizationHeader(),this.empleadoService.getTenantHeader()]
    });

  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Nombre': [null],
      'Apellido': [null],
      'NroDocumento': [null],
      'Cuit': [null]
    });
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();    

    var index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre", this.searchForm.value.Nombre);

    index = this.query.params.findIndex(obj => obj.key === "Apellido");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Apellido;
    else
      this.query.addParams("Apellido", this.searchForm.value.Apellido);

    index = this.query.params.findIndex(obj => obj.key === "Cuit");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Cuit;
    else
      this.query.addParams("Cuit", this.searchForm.value.Cuit);

    index = this.query.params.findIndex(obj => obj.key === "NroDocumento");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.NroDocumento;
    else
      this.query.addParams("NroDocumento", this.searchForm.value.NroDocumento);
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  showUserImage(item: SearchEmpleadoItemDto) {
    return (item?.FotoPerfilUrl != null && item?.FotoPerfilUrl?.length > 0);
  }

  add() {
    if(this.canAdd){
      this.router.navigate(['empleado-edit', 0]);
    }
    else{
      this.sharedFunctions.showMessage("No tiene permisos para crear un nuevo empleado", "Error");
    }
  }

  edit(item: SearchEmpleadoItemDto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['empleado-edit', item.Id]);
  }

  onExport() {
    var search = new SearchEmpleadoRequestDto(null, null,null,null,null,null,null,null,null,null,null,null, null, null, null, null, this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.empleadoService.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Empleados_" + this.datePipe.transform(new Date(), "yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
      (err: HttpErrorResponse) => {
        this.isExporting = false;
        return this.sharedFunctions.handleError(err);
      })
  }
}
